// extracted by mini-css-extract-plugin
export default {"card":"card_card__r4HsF","disabled":"card_disabled__x6ToA","getCard":"card_getCard__5XRJn","head":"card_head__qTelj","title":"card_title__YZczf"};